import { afterNextRender, ChangeDetectionStrategy, Component, computed, forwardRef, signal } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { InputTextConfig } from "./input-text.config";
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector:    'v-input-text',
    templateUrl: './input-text.component.haml',
    styleUrls:   ['./input-text.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VInputTextComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VInputTextComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VInputTextComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, InputTextModule, ReactiveFormsModule, TranslateModule]
})
export class VInputTextComponent extends InputFormWrapper<InputTextConfig, string> {
    protected readonly _baseConfig: InputTextConfig = InputTextConfig.baseTheme.Default;
    private _maxLength = signal<number>(undefined);
    public maxLength = computed(() => this.config().maxlength ?? this._maxLength());

    ngOnInit() {
        super.ngOnInit();
        afterNextRender(() => this.setMaxLength(), { injector: this.injector });
    }

    writeValue(value: string): void {
        if (!!value && typeof value !== "string") return;
        if (this.config().maxlength) value = value?.substring(0, this.config().maxlength);
        super.writeValue(value);
    }

    setMaxLength(): void {
        const validator = this.formControlDirective()?.form?.validator;
        if (!validator) return;
        const errors = validator(new FormControl({length: Infinity}));
        const length = errors?.maxlength?.requiredLength;
        if (length)this._maxLength.set(length);
    }
}

export type TextInputAffix = string;